import { FC } from "react";
import { TableBody } from "@mui/material";
import { CommitmentOverview } from "@/services/cloudchipr.api";
import { CommitmentsOverviewCommitmentsTableRow } from "@/components/pages/commtiments/overview/content/components/commitments/components/CommitmentsOverviewCommitmentsTableRow";

interface CommitmentsOverviewCommitmentsTableBodyProps {
  data: CommitmentOverview["commitments"] | null;
}
export const CommitmentsOverviewCommitmentsTableBody: FC<
  CommitmentsOverviewCommitmentsTableBodyProps
> = ({ data }) => {
  if (!data) {
    return null;
  }

  return (
    <TableBody>
      {data.map((item) => (
        <CommitmentsOverviewCommitmentsTableRow
          key={item.name}
          commitmentItem={item}
        />
      ))}
    </TableBody>
  );
};
